import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
